import React from 'react';
import { AppButton, Box, costFormater, Inscription } from '@common-fe/common-fe';

import UnappliedFundsOrganizationsHint from './UnappliedFundsOrganizationsHint';

interface Props {
  amount: number;
  isOrganizationsList: boolean;
  organizationNames: string[];
  organizationsCount: number;
  onViewOrganizations: () => void;
  onViewDetails: () => void;
}

const NON_BREAKING_SPACE = ' ';

const UnappliedFundsInlineBanner: React.FC<Props> = ({
  amount,
  isOrganizationsList,
  organizationNames,
  organizationsCount,
  onViewOrganizations,
  onViewDetails,
}) => {
  const organizationsTitle = `${organizationsCount} ${organizationsCount === 1 ? 'organization' : 'organizations'}`;

  return (
    <Box
      data-testid="unapplied-funds-banner"
      direction="row"
      justify="between"
      align="center"
      gap="spacing24"
      background="warningContainer"
      round="container1Round"
      pad={{ vertical: 'spacing12', horizontal: 'spacing24' }}
      margin={{ bottom: 'spacing24' }}
    >
      <Box direction="row" align="center" data-testid="unapplied-funds-banner_text">
        {isOrganizationsList ? (
          <>
            <Inscription lineHeight="20px">
              You have an unapplied funds balance of{NON_BREAKING_SPACE}
            </Inscription>
            <Inscription lineHeight="20px" weight="bold" data-testid="unapplied-funds-banner_amount">
              {costFormater(amount, true)}
            </Inscription>
            <Inscription lineHeight="20px">{NON_BREAKING_SPACE}across{NON_BREAKING_SPACE}</Inscription>
            <UnappliedFundsOrganizationsHint
              testId="unapplied-funds-banner_organizations"
              title={organizationsTitle}
              organizationNames={organizationNames}
              organizationsCount={organizationsCount}
              onViewAll={onViewOrganizations}
            />
            <Inscription lineHeight="20px">.</Inscription>
          </>
        ) : (
          <>
            <Inscription lineHeight="20px">
              You have an unapplied funds balance:{NON_BREAKING_SPACE}
            </Inscription>
            <Inscription lineHeight="20px" weight="bold" data-testid="unapplied-funds-banner_amount">
              {costFormater(amount, true)}
            </Inscription>
          </>
        )}
      </Box>
      <AppButton
        testId="unapplied-funds-banner_action"
        onClick={isOrganizationsList ? onViewOrganizations : onViewDetails}
      >
        {isOrganizationsList ? 'View Organizations' : 'View Details'}
      </AppButton>
    </Box>
  );
};

export default UnappliedFundsInlineBanner;
